import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";
// import { Divider, Steps } from "antd";
// import { formatDateTime } from "helpers/FormatDate";
import { useState, useEffect } from "react";
// import { FormatApprovalStatus } from "helpers/FormatApprovalStatus";
import { formatDate } from "../../../../utils/hooks/convertDate";
import { Stack } from "@mui/material";
import {
  Check,
  CircleOutlined,
  Close,
  Error as ErrorIcon,
  CheckCircle,
} from "@mui/icons-material";
import { BsExclamationTriangle } from "react-icons/bs";
import { format } from "date-fns";

const getSLAStyle = (status) => {
  console.log({ status });
  switch (true) {
    case status === "OnTrack":
      return {
        backgroundColor: "#1e8f3c22",
        color: "#1e8f3c",
        icon: Check,
      };

    case status === "AtRisk":
      return {
        backgroundColor: "#e99e1c22",
        color: "#e99e1c",
        icon: BsExclamationTriangle,
      };

    case status === "Breached":
      return {
        backgroundColor: "#c4313122",
        color: "#c43131",
        icon: Close,
      };

    case status === "CompletedWithingSLA":
      return {
        backgroundColor: "#1e8f3c22",
        color: "#1e8f3c",
        icon: Check,
      };

    case status === "CompletedBreached":
      return {
        backgroundColor: "#ff8f8f22",
        color: "#ff8f8f",
        icon: Check,
      };

    default:
      return {
        backgroundColor: "#1e8f3c22",
        color: "#1e8f3c",
        icon: CircleOutlined,
      };
  }
};

// Custom StepIcon Component
const CustomStepIcon = (props) => {
  const { active, completed, error } = props;

  // Determine which icon to show based on state
  const getIcon = () => {
    if (error) {
      return <ErrorIcon sx={{ color: "#d32f2f", fontSize: "1.5rem" }} />;
    }
    if (completed) {
      return <CheckCircle sx={{ color: "#2e7d32", fontSize: "1.5rem" }} />;
    }
    if (active) {
      return <CircleOutlined sx={{ color: "#1976d2", fontSize: "1.5rem" }} />;
    }
    return <CircleOutlined sx={{ color: "#9e9e9e", fontSize: "1.5rem" }} />;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "24px",
        height: "24px",
      }}
    >
      {getIcon()}
    </div>
  );
};

export default function ApprovalDrawer({
  open,
  toggleDrawer,
  approvalItems,
  allData,
}) {
  const [selectedName, setSelectedName] = useState(
    approvalItems && approvalItems[0] ? approvalItems[0]?.createdBy : ""
  );

  useEffect(() => {
    if (approvalItems && approvalItems[0]) {
      setSelectedName(approvalItems[0]?.createdBy);
      // setMessage(approvalItems[0]?.notes || "No Message");
    }
  }, [approvalItems]);

  const [showAllSteps, setShowAllSteps] = useState(false);
  const toggleStepsVisibility = () => {
    setShowAllSteps(!showAllSteps);
  };

  const b = getSLAStyle(allData?.slaStatus);

  return (
    <div className="text-[#18BB0C]">
      <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
        <div className="flex justify-between  bg-[#305F32] px-4 py-2 items-center">
          <h2 className="text-lg text-white font-bold ">Approval Stages</h2>
          <button
            onClick={() => toggleDrawer(false)}
            className="text-white text-[28px]"
          >
            &times;
          </button>
        </div>
        <div className="min-w-[250px] p-4 bg-white">
          <div className="text-sm">
            <p className="font-medium mb-4">
              Status: {allData?.status || allData?.approvalStatus}
            </p>
            <p className=" font-medium mb-4">
              Levels of Approval: {allData?.totalLevel || "---"}
            </p>
            <p className="font-medium mb-4">
              Approval Step: {allData?.approvalSteps || "---"}
            </p>
            <Stack
              direction={"row"}
              alignItems={"center"}
              gap={0.5}
              className="font-medium mb-4"
              sx={
                {
                  // color: b.color,
                }
              }
            >
              <span className="">SLA Status:</span>
              <div
                className="flex items-center justify-center font-[500] text-[10px] px-2 py-1 rounded-full gap-1"
                style={{
                  backgroundColor: b.backgroundColor,
                }}
              >
                <b.icon fontSize={"10px"} size={10} />
                <span className="text-xs">
                  {allData?.slaStatus || "Not Applicable"}
                </span>
              </div>
            </Stack>

            <p className=" font-medium mb-4">
              Next Approving Group: {allData?.nextApprovingGroupName || "---"}
            </p>
          </div>
          {approvalItems?.length < 1 ? (
            <div className="font-semibold text-center my-6">
              Process is Pending
            </div>
          ) : (
            <div className="min-h-[200px]">
              <Box sx={{ maxWidth: 400 }}>
                <Stepper
                  activeStep={approvalItems?.length}
                  orientation="vertical"
                >
                  {approvalItems
                    ?.slice(0, showAllSteps ? approvalItems.length : 3)
                    .map((step, index) => {
                      const a = getSLAStyle(step?.slaStatus);
                      const isError =
                        step?.status === "Rejected" ||
                        step?.status === "Declined";
                      const isCompleted = step?.status === "Approved";

                      return (
                        <Step
                          active={!isError}
                          completed={isCompleted}
                          error={isError}
                          expanded
                          key={index}
                        >
                          <StepLabel
                            StepIconComponent={CustomStepIcon}
                            sx={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#07540A",
                            }}
                            error={isError}
                          >
                            Request Approval (
                            <span
                              className={
                                step?.status === "Approved"
                                  ? "text-[#149d39]"
                                  : isError
                                  ? "text-[#d32f2f]"
                                  : "text-[#ffa749]"
                              }
                            >
                              {step?.status}
                            </span>
                            )
                          </StepLabel>
                          <StepContent
                            hidden={false}
                            className="flex flex-col gap-2"
                          >
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#07540A",
                              }}
                            >
                              Approver:{" "}
                              <span className="font-[400] text-[#07540A]">
                                {step?.createdBy} ({step?.groupName})
                              </span>
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#1e8f3c",
                              }}
                            >
                              <span className="font-medium text-[12px] text-[#07540A]">
                                Comment:
                              </span>{" "}
                              {step?.approvalComment}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#1e8f3c",
                              }}
                            >
                              <span className="font-medium text-[12px] text-[#07540A]">
                                Timestamp:
                              </span>{" "}
                              {step?.createdAt
                                ? format(
                                    new Date(step?.createdAt),
                                    "dd/MM/yyyy hh:mm aa"
                                  )
                                : "--"}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#1e8f3c",
                              }}
                            >
                              <span className="font-[500] text-[12px] text-[#07540A]">
                                SLA Breached:
                              </span>{" "}
                              {step?.isSLABreached ? "Yes" : "No"}
                            </Typography>

                            <Stack
                              direction={"row"}
                              alignItems={"flex-start"}
                              gap={1}
                              sx={{
                                marginTop: "3px",
                                color: a.color,
                              }}
                            >
                              <span className="text-[12px] text-[#07540A]">
                                SLA Status:
                              </span>
                              <div
                                className="flex items-center justify-center font-[500] text-[10px] px-2 py-1 rounded-full gap-1"
                                style={{
                                  backgroundColor: a.backgroundColor,
                                }}
                              >
                                <a.icon fontSize={"10px"} size={10} />
                                <span className="text-xs">
                                  {step?.slaStatus || "Not Applicable"}
                                </span>
                              </div>
                            </Stack>
                          </StepContent>
                        </Step>
                      );
                    })}
                </Stepper>
              </Box>
            </div>
          )}

          <div className="w-[350px] text-[#07540A] bg-white rounded-md">
            <div className="mt-6">
              {approvalItems?.length > 3 && (
                <button
                  className="text-sm text-gray-500"
                  onClick={toggleStepsVisibility}
                >
                  {showAllSteps ? <>less &uarr;</> : <>more &darr;</>}
                </button>
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
